import Vue from 'vue'
import Router from 'vue-router'
import store from "@/assets/store/store";


const Tasks = () => import('@/components/Tasks')
const Reports = () => import('@/components/Reports')
const Users = () => import('@/components/Users')
const Login = () => import('@/components/Login')
const Logout = () => import('@/components/Logout')
const Members = () => import('@/components/Members')
const MembersTeam = () => import('@/components/MembersTeam')
const Register = () => import('@/components/Register')
const Dashboard = () => import('@/components/Dashboard')
const DashboardAdmin = () => import('@/components/DashboardAdmin')
const RegisterInvite = () => import('@/components/RegisterInvite')
const Profile_New = () => import('@/components/Profile_New')
const MyChallenges = () => import('@/components/MyChallenges')
const MyWinners = () => import('@/components/MyWinners')
const MyWinnersList = () => import('@/components/MyWinnersList')
const MyReports = () => import('@/components/MyReports')
const Challenges = () => import('@/components/Challenges')
const OrganizationChallenges = () => import('@/components/OrganizationChallenges')
const ChallengePhotos = () => import('@/components/ChallengePhotos')
const ChallengePhotosStyle = () => import('@/components/ChallengePhotosStyle')
const AdminHub = () => import('@/components/AdminHub')
const AdminReport = () => import('@/components/AdminReport')
const AdminSupport = () => import('@/components/AdminSupport')
const ForgotPass = () => import('@/components/password/ForgotPass')
const RequestPassword = () => import('@/components/password/RequestPassword')
const Invited = () => import('@/components/Invited')
const Judges = () => import('@/components/Judges')
const Location = () => import('@/components/Location')
const SlotForm = () => import('@/components/SlotForm')
const ChangePassword = () => import("@/components/password/ChangePassword");
const SupportRequest = () => import("@/components/SupportRequest");
const Invoices = () => import("@/components/users/Invoices");
const AdminInvoices = () => import("@/components/Invoices");
const Balance = () => import("@/components/users/Balance");
const Emails = () => import("@/components/emails/Emails");
const Email = () => import("@/components/emails/Email");
const PromoList = () => import("@/components/PromoList");
const Suspicious = () => import("@/components/Suspicious");
const Program = () => import("@/components/Program");
const Schedule = () => import("@/components/Schedule");
const SelectCompany = () => import("@/components/SelectCompany");
const AdminMembersTeam = () => import("@/components/AdminMembersTeam");
const WCOSRoundsSetup = () => import("@/components/SlotFormWCOS");
const AnnoucmentUpload = () => import("@/components/AnnoucmentUpload");
const Resource = () => import("@/components/Resource");
const Graphs = () => import("@/components/Graphs");

Vue.use(Router)

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: '/promo-list',
      name: 'Promo codes',
      component: PromoList,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'superior_admin' ) ) { next() }
        else if( store.state.userLoggedIn === true ) { next('/my-challenges'); }
        else { next('/login'); }
      }
    },
    {
      path: '/tasks',
      name: 'Tasks',
      component: Tasks,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'objectives' ) ) { next(); }
        else if( store.state.userLoggedIn === true ) { next('/my-challenges'); }
        else { next('/login'); }
      }
    },
    {
      path: '/company',
      name: 'Select Company',
      component: SelectCompany
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'report' ) ) { next(); }
        else if( store.state.userLoggedIn === true ) { next('/my-challenges'); }
        else { next('/login'); }
      }
    },
    {
      path: '/users/:tab',
      name: 'Users',
      component: Users,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else if( store.state.userLoggedIn === true ) { next('/my-challenges'); }
        else { next('/login'); }
      },
      props: true
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else if( store.state.userLoggedIn === true ) { next('/my-challenges'); }
        else { next('/login'); }
      }
    },
    {
      path: '/wcosr/:selectedChID',
      name: 'WCOSRoundsSetup',
      component: WCOSRoundsSetup,
      beforeEnter: (to, from, next) => {
        next();
      },
      props: true
    },
    {
      path: '/challenge',
      name: 'Program',
      component: Program,
       beforeEnter: (to, from, next) => {
          if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
          else { next('/'); }
        }
    },
    {
      path: '/annoucment_upload',
      name: 'AnnoucmentUpload',
      component: AnnoucmentUpload,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else { next('/login'); }
      }
    },
    {
      path: '/resource',
      name: 'Resource',
      component: Resource,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else { next('/login'); }
      }
    },
    {
      path: '/graphs',
      name: 'Graphs',
      component: Graphs
    },
    {
      path: '/challenge/location',
      name: 'Select Location',
      component: Location
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else
        {
          next('/');
        }
      }
    },
    {
      path: '/dashboardadmin',
      name: 'DashboardAdmin',
      component: DashboardAdmin,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else
        {
          next('/');
        }
      }
    },
    {
      path: '/members',
      name: 'Members',
      component: Members
    },
    {
      path: '/team',
      name: 'MembersTeam',
      component: MembersTeam
    },
    {
      path: '/adminteam',
      name: 'AdminMembersTeam',
      component: AdminMembersTeam
    },
    {
      path: '/invited',
      name: 'Invited',
      component: Invited,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else
        {
          next('/');
        }
      }
    },
    {
      path: '/judges',
      name: 'Judges',
      component: Judges,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else
        {
          next('/');
        }
      }
    },
    {
      path: '/photos/:id',
      name: 'Challenge photos',
      component: ChallengePhotos,
      props: true,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else
        {
          next('/');
        }
      }
    },
    {
      path: '/photos/style/:id',
      name: 'Challenge photos style',
      component: ChallengePhotosStyle,
      props: true,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true && store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/login'); }
      }
    },
    {
      path: '/invite/:email',
      name: 'RegisterInvite',
      component: RegisterInvite,
      props: true
    },
    {
      path: '/requestreset/:email',
      name: 'Request Password',
      component: RequestPassword,
      props: true
    },
    {
      path: '/reset',
      name: 'Forgot Password',
      component: ForgotPass
    },
    {
      path: '/change',
      name: 'Change Password',
      component: ChangePassword
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile_New,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else {
          store.commit('updateRedirectTo', 'profile' );
          next('/login');
        }
      }
    },
    {
      path: '/support-request',
      name: 'Support Request',
      component: SupportRequest,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else { next('/login'); }
      }
    },
    {
      path: '/admin/invoices',
      name: 'AdminInvoices',
      component: AdminInvoices,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true && store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/login'); }
        
      }
    },
    {
      path: '/invoices',
      name: 'Invoices',
      component: Invoices,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else { next('/login'); }
      }
    },
    {
      path: '/balance',
      name: 'Balance',
      component: Balance,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else { next('/login'); }
      }
    },
    {
      path: '/my-challenges',
      name: 'My Challenges',
      component: MyChallenges,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else { next('/login'); }
      }
    },
    {
      path: '/my-reports',
      name: 'My Reports',
      component: MyReports,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else { next('/login'); }
      }
    },
    {
      path: '/my-winners',
      name: 'My Winners',
      component: MyWinners,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else { next('/login'); }
      }
    },
    {
      path: '/my-winners-list/:challengeID',
      name: 'My Winners List',
      props: true,
      component: MyWinnersList,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else if( !store.state.userLoggedIn )
        {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
        else { next('/login'); }
      }
    },
    {
      path: '/challenges',
      name: 'Challenges',
      component: Challenges,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/organizationchallenges',
      name: 'OrganizationChallenges',
      component: OrganizationChallenges,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/suspicious',
      name: 'Suspicious',
      component: Suspicious,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/admin-hub',
      name: 'AdminHub',
      component: AdminHub,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/admin-report',
      name: 'AdminReport',
      component: AdminReport,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/admin-support',
      name: 'AdminSupport',
      component: AdminSupport,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/challenge/:id/status/:statusPayment',
      name: 'Challenge Setup',
      component: SlotForm,
      props: true,
      beforeEnter: (to, from, next) => {
        console.log( 'CHALLENNGE SETUP success' );

        let values = to.path.split('/');
        
        console.log( 'CHALLENNGE SETUP redirect' );
        store.commit('updateSelectedChID', values[2] );
        store.commit('updatePaySuccess', true );
        store.commit('updateRedirectTo', '/challenge-setup' );
        next('/challenge-setup');
        //next({ path: '/challenge-setup', name: 'ChallengeSetup', params: { statusPayment: 'success' } });
                 
      }
    },
    {
      path: '/challenge-setup/:id',
      name: 'Challenge Setup',
      component: SlotForm,
      props: true,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn ) {
          store.commit('updateSelectedChID', values[2] );
          store.commit('updateRedirectTo', '/challenge-setup' );
          next('/challenge-setup');
        }
        else if( !store.state.company ) {
          console.log('/challenge-setup/:id 11111111' );
          store.commit('updateSelectedChID', values[2] );
          store.commit('updateRedirectTo', '/challenge-setup' );
          next('/company');
        }
        else if( !store.state.userLoggedIn )
        {
          if( to.path )
          {
            let values = to.path.split('/');
            console.log('??',values );
            if( values[2] )
            {
              console.log('??2',values );
              store.commit('updateSelectedChID', values[2] );
              store.commit('updateRedirectTo', '/challenge-setup' );
              next('/login');
            }
            else
            {
              next('/');
            }

          }
          else
          {
            
            next('/');
          }


        }
        else
        {
          next('/');
        }
      }
    },
    {
      path: '/challenge/:id',
      name: 'Challenge Setup',
      component: SlotForm,
      props: true,
      beforeEnter: (to, from, next) => {
        console.log( 'CHALLENNGE SETUP 2' );
        

        if( store.state.userLoggedIn ) {
          if( to.path )
          {
            let values = to.path.split('/');
            if( values[2] )
            {
              store.commit('updateSelectedChID', values[2] );
              store.commit('updateRedirectTo', '/challenge-setup' );
              next('/challenge-setup');
            }
            else
            {
              next('/');
            }
          }
          else
          {
            next('/');
          }
        }
        else if( !store.state.userLoggedIn )
        {
          if( to.path )
          {
            let values = to.path.split('/');
            console.log('??',values );
            if( values[2] )
            {
              console.log('??2',values );
              store.commit('updateSelectedChID', values[2] );
              store.commit('updateRedirectTo', '/challenge-setup' );
              next('/login');
            }
            else
            {
              next('/');
            }
          }
          else
          {
            next('/');
          }
        }
        else
        {
          next('/');
        }
      }
    },
    {
      path: '/challenge-setup',
      name: 'Challenge Setup',
      component: SlotForm,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { 
          if( store.state.company )
          {
            next(); 
          }
          else
          {
            console.log('/challenge-setup/:id 2222222' );
            next('/company');
          }
        }
        else {
          store.commit('updateRedirectTo', to.path );
          next('/login');
        }
      }
    },

    {
      path: '/emails',
      name: 'Emails',
      component: Emails,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/email-setup',
      name: 'Email',
      component: Email,
      beforeEnter: (to, from, next) => {
        if( store.getters.userPrivileges.includes( 'admin' ) ) { next(); }
        else { next('/'); }
      }
    },
    {
      path: '/:name',
      name: 'Program',
      component: Program,
      props: true,
      beforeEnter: (to, from, next) => {
        if( store.state.userLoggedIn === true ) { next(); }
        else { next('/login'); }
      }
    },
  ]
})

router.beforeEach(( to, from, next ) =>
{

  if( to.path !== '/login' || to.path !== '/company' )
  {
    //store.commit('updateRedirectTo', '/' );
  }

  /** /
  if( to.path !== '/' && to.path !== '/login/26pbgEEF0JsJupIH2Usu22ZlwdxPZntLFTxFwu1mskWGerhmNO' && to.path !== '/app' && !to.path.includes('/requestreset')  )
  {
    //console.log( '' + ( store ? ( store.getters.userPrivileges ? ( store.getters.userPrivileges.includes( 'admin' ) ?' je' : 'neni admin' ) : 'userPriv' ) : 'store'  ) );

    if( to.path !== 'https://www.pixcham.com/terms' || to.path !== 'https://www.pixcham.com/privacy' || to.path !== 'https://www.pixcham.com/official-rules' || to.path !== 'https://www.pixcham.com/privacy' || to.path !== 'https://www.pixcham.com/helpcenter' )
    {
      next();
    }
    else if( store && store.getters.userPrivileges && store.getters.userPrivileges.includes( 'admin' ) )
    {
      next();
    }
    else
    {
      next('/');
    }
  }
  else
  {
    //console.log('?????');
   /**/

    next();
    /** /
  }

    /**/




});

export default router;
